import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface SubProcessor {
  provider: string;
  /** Under `sub` in the legal namespace. */
  key: "aws" | "google_sign_in" | "google_maps" | "google_fonts" | "hotjar";
}

// Derived from the outbound calls the code actually makes: the AWS SDK clients
// in s3.ts and ses.ts, the Google OAuth and Places calls in the front ends, the
// Distance Matrix call in distance/, the Google Fonts @import in index.html,
// and the Hotjar snippet. MaxMind is deliberately absent — that lookup runs
// against a database on our own server, so no request leaves it.
const SUB_PROCESSORS: SubProcessor[] = [
  {
    provider: "Amazon Web Services",
    key: "aws",
  },
  {
    provider: "Google (Sign-In)",
    key: "google_sign_in",
  },
  {
    provider: "Google Maps Platform",
    key: "google_maps",
  },
  {
    provider: "Google Fonts",
    key: "google_fonts",
  },
  {
    provider: "Hotjar (Contentsquare)",
    key: "hotjar",
  },
];

/** Wide content, so it scrolls inside itself rather than the page. */
const SubProcessorTable: React.FC = () => {
  const { t } = useTranslation("legal");

  return (
    <Box sx={{ overflowX: "auto", marginBottom: 3 }}>
      <Table size="small" sx={{ minWidth: 560 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700 }}>
              {t("common.provider")}
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }}>{t("common.does")}</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>
              {t("common.receives")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {SUB_PROCESSORS.map((row) => (
            <TableRow key={row.provider}>
              <TableCell sx={{ verticalAlign: "top", fontWeight: 600 }}>
                {row.provider}
              </TableCell>
              <TableCell sx={{ verticalAlign: "top" }}>
                {t(`sub.${row.key}.purpose`)}
              </TableCell>
              <TableCell sx={{ verticalAlign: "top" }}>
                {t(`sub.${row.key}.receives`)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default SubProcessorTable;
